// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Detail from './components/VUE/Detail.vue'
import Footer from "./components/VUE/Footer.vue";


import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import Header from "./components/VUE/Header";

import { SliderPlugin } from "@syncfusion/ej2-vue-inputs";

Vue.use(SliderPlugin);
Vue.use(VueMaterial);

var detail = new Vue({
  el: '#detail',
  components: { Detail },
  template: '<Detail/>'
});


new Vue({
  el: '#header',
  components: { Header },
  template: '<Header/>'
});

new Vue({
  el: '#footer',
  components: { Footer },
  template: '<Footer/>'
});

export default {detail};



// WEBPACK FOOTER //
// ./src-detail/main.js